























import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full.esm'
import { Component, Vue, Ref, Prop } from 'vue-property-decorator'
import Dropdown, { DropdownOption } from '@/components/Controls/Dropdown.vue'
import Calendar from '@/components/Controls/Calendar.vue'
import { Services } from 'truemarket-modules/src/services'
import EnumValueType from 'truemarket-modules/src/models/api/enumerations/EnumValueType'

@Component({
  components: {
    ValidationProvider,
    ValidationObserver,
    Dropdown,
    Calendar
  }
})
export default class AssessmentDetails extends Vue {
  @Ref('observer') readonly form!: InstanceType<typeof ValidationObserver>

  created () {
    this.$emit('submissionHandler', this.submit)
    this.$emit('validationHandler', this.validate)
  }

  mounted () {
    Services.API.Enumerations.GetEnumValuesForType(EnumValueType.ValuationPurpose).then((vals) => {
      this.purposes = vals.filter((f) => { return f.Value !== 'GeneralInformation' })
        .map((v) => ({ label: v.Label, value: v.ValueId }))
    })

    const tempValId = this.$route.query.tempValuationId as string
    const pristine = this.form.flags.pristine

    if (tempValId && pristine) this.loadData(tempValId)
  }

  loadData (tempValId: string) {
    Services.API.ValuationForm.ResumeTempValuation(
      { TempValuationId: tempValId, Key: 'AssessmentDetails' }
    ).then((response: any) => {
      if (!response.Data) return

      this.purpose = response.Data.Purpose
      if (response.Data.RetrospectiveDate) {
        this.date = new Date(response.Data.RetrospectiveDate)
      }
    })
  }

  validate () {
    return this.form.validateWithInfo()
  }

  @Prop({ required: true })
  public tempValuationId!: string;

  async submit () {
    console.log('//////////////////////////////////////////// -------------------------')
    console.log(this.date)
    if (this.date) {
      this.date.setHours(14, 0, 0, 0)
    }

    const data = {
      Purpose: this.purpose ?? '',
      RetrospectiveDate: this.date?.toISOString() ?? ''
    }
    const request = {
      TempValuationId: this.tempValuationId,
      Version: Vue.prototype.$valuationFromVersion,
      Key: 'AssessmentDetails',
      Data: JSON.stringify(data)
    }
    return await Services.API.ValuationForm.ProcessTempValuation(request).then(response => {
      return {
        data,
        response,
        success: true
      }
    }).catch((e) => {
      return {
        data,
        response: e,
        success: false
      }
    })
  }

  date: Date | null = null
  purpose: string | null = null
  purposes: DropdownOption[] = []
}
